import { proxy } from "valtio";
import { BusinessUserData } from "../api/business/auth/types";

export const businessUserDataStore = proxy<{
  businessUserData: BusinessUserData | undefined;
}>({
  businessUserData: undefined,
});
